export function disableKeyboardInput(input: HTMLInputElement) {
    if (input) {
        input.setAttribute('readonly', 'true');
        setTimeout(() => {
            input.removeAttribute('readonly');
        }, 100);
    }
}